import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ModalBasicLayout from "./ModalBasicLayout";
import ContainerModalActions from "../Containers/ContainerModalActions";
import {
  BUTTON_CONTINUE,
  BUTTON_GO_BACK,
  MODAL_OVERLAP_CONFLICTS_DESCRIPTION,
  MODAL_OVERLAP_CONFLICTS_TITLE,
  OVERLAPS_WITH,
  UNKNOWN,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import i18next from "i18next";

function getDisplayName(marker) {
  const baseName =
    marker?.name ||
    marker?.longName ||
    marker?.metadata?.formatted_address ||
    i18next.t(UNKNOWN);
  if (marker?.type === "radius") {
    const r = Number(marker.radius) || 0;
    if (r >= 1000) {
      const km = Math.round(r / 1000);
      return `${baseName} (${km}km around)`;
    }
    if (r > 0) {
      return `${baseName} (${r}m around)`;
    }
  }
  return baseName;
}

const ModalOverlapConflicts = ({
  open,
  onClose,
  conflicts = [],
  onContinueWithoutOverlaps,
}) => {
  const { t } = useTranslationApp();
  const items = conflicts.map(({ a, b }) => ({
    aName: getDisplayName(a),
    bName: getDisplayName(b),
  }));

  return (
    <ModalBasicLayout
      modalOpen={open}
      onCloseModal={onClose}
      fullWidth={true}
      maxWidth="sm"
      scroll="paper"
      title={t(MODAL_OVERLAP_CONFLICTS_TITLE)}
      description={t(MODAL_OVERLAP_CONFLICTS_DESCRIPTION)}
      sx={{
        zIndex: 1400,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            maxHeight: 320,
            overflowY: "auto",
            pr: 1,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            backgroundColor: "background.paper",
          }}
        >
          {items.map((item, idx) => (
            <Box
              key={idx}
              sx={{
                borderBottom: idx < items.length - 1 ? "1px solid" : "none",
                borderColor: "divider",
              }}
            >
              <Typography variant="body2">
                <strong>{item.aName}</strong> {t(OVERLAPS_WITH)}{" "}
                <strong>{item.bName}</strong>
              </Typography>
            </Box>
          ))}
        </Box>

        <ContainerModalActions
          hasPadding={false}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_CONTINUE,
            onClick: onContinueWithoutOverlaps,
          }}
          propsSecondaryButton={{
            showButton: true,
            text: BUTTON_GO_BACK,
            onClick: onClose,
          }}
        />
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalOverlapConflicts;
